import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Lightbox from 'react-images';
import './Image.css';

export default class ImageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      isLightBoxOpen: false,
    }
    this.onImageLoad = this.onImageLoad.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.closeLightbox = this.closeLightbox.bind(this);
  }

  openLightbox () {
    this.setState({
      isLightBoxOpen: true
    })
  }

  closeLightbox () {
    this.setState({
      isLightBoxOpen: false,
    })
  }

  onImageLoad() {
    if (this.refs.img) {
      this.setState({ loaded: true });
    }
  }

  componentDidMount() {
    var imgTag = ReactDOM.findDOMNode(this.refs.img);
    var imgSrc = imgTag.getAttribute('src');
    var img = new window.Image();
    img.onload = this.onImageLoad;
    img.src = imgSrc;
  }

  render() {
    var { className, src, ...props } = this.props;
    var rootClassName = className ? className + ' image' : 'image';
    if (this.state.loaded) {
      rootClassName += ' image-loaded';
    }
    return (
      <div>
        <img
          alt="Click to expand"
          ref="img"
          src={src}
          {...props}
          className={rootClassName}
          onClick={this.openLightbox} />
        <Lightbox
          images={[{src: src}]}
          isOpen={this.state.isLightBoxOpen}
          onClose={this.closeLightbox}
          backdropClosesModal={true}
          enableKeyboardInput={true}
          showImageCount={false}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/helpers/ImageLightbox.jsx